/**
 * SSR-safe rules for `r-button` pseudo-classes.
 *
 * widget-react injects this once per library via `ComponentLibraryModule.stylesheet`.
 * The sheet owns `background-color`, `color`, and `border-color` so `:hover`
 * can win — those properties on an inline style beat any stylesheet rule.
 * Resting values arrive as `--rulecms-button-fill` / `-ink` / `-border` on
 * the element. A column background override rewrites the fill slots and
 * derives hover/active with `color-mix`, so an arbitrary red does not keep
 * the brand-blue hover.
 *
 * Outline is never cleared: the designed ring is a `box-shadow` on
 * `:focus-visible`, on top of the browser's native focus outline.
 */
export const BUTTON_LIBRARY_STYLESHEET = `
[data-rulecms-button] {
  background-color: var(--rulecms-button-fill);
  color: var(--rulecms-button-ink);
  border-color: var(--rulecms-button-border, var(--rulecms-button-fill));
}
[data-rulecms-button]:hover:not(:disabled):not([aria-disabled="true"]) {
  background-color: var(--rulecms-button-fill-hover);
  color: var(--rulecms-button-ink-hover, var(--rulecms-button-ink));
  border-color: var(--rulecms-button-fill-hover);
}
[data-rulecms-button]:active:not(:disabled):not([aria-disabled="true"]) {
  background-color: var(--rulecms-button-fill-active);
  border-color: var(--rulecms-button-fill-active);
}
[data-rulecms-button][data-rulecms-button-variant="outline"]:hover:not(:disabled):not([aria-disabled="true"]),
[data-rulecms-button][data-rulecms-button-variant="ghost"]:hover:not(:disabled):not([aria-disabled="true"]) {
  border-color: var(--rulecms-button-border, var(--rulecms-button-ink));
}
[data-rulecms-button][data-rulecms-button-variant="link"]:hover:not(:disabled):not([aria-disabled="true"]),
[data-rulecms-button][data-rulecms-button-variant="link"]:active:not(:disabled):not([aria-disabled="true"]) {
  background-color: transparent;
  border-color: transparent;
}
[data-rulecms-button]:focus-visible {
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--rulecms-button-ring, var(--rulecms-button-ink)) 40%, transparent);
}
`.trim();
